import './ReportSection.css';

const ReportSectionTableRow = ({ title, text, isEven, altText, icon }) => {

  /* TODO: replace with flex grid to add white borders as in report file (after upgrade to Bulma 1.0.0)*/
  let backgroundClass = isEven ? "row-dark" : "row-light";
  let alt = altText ? altText : "";
  let icn = icon ? icon : title.toLowerCase().replace(/ /g, "_");  
  icn= process.env.PUBLIC_URL + "/icons/" + icn + ".svg";

  return (    
    <div className={`columns is-vcentered ${backgroundClass}`}>
      <div className="column is-3 has-text-centered">
        <span className="icon is-large"><img src={icn} alt={alt}></img></span>
        <p>{title}</p>
      </div>
      <div className="column is-9">
        {text}
      </div>
    </div>
  );
};

export default ReportSectionTableRow;
